// extracted by mini-css-extract-plugin
export default {"JobCategory":"job-category_JobCategory__w7qGA"};